import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import "./utils/i18n/i18n";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const container = document.getElementById("root");
const root = createRoot(container);
const theme = createTheme({
	palette: {
		primary: { main: "#0054a6", faded: "rgba(0, 84, 166, 0.1)", half: "rgba(0, 84, 166, 0.5)" },
		secondary: { main: "#800303" },
	},
});
root.render(
	// <React.StrictMode>
	<Provider store={store}>
		<ThemeProvider theme={theme}>
			<ToastContainer />
			<App />
		</ThemeProvider>
	</Provider>
	// </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
